function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ServiceFactory from "../../service";
import endpoints from "../../endpoints";
import { headers as bearerHeaders } from "../../endpoints/market-intelligence";

// Shipped list (CONTENT_HUB_SHIP_ONCE_2026-10-02): every placement a piece has, with Open / Update / Remove.
// Shared by the Builder's Ship stage and the piece page's Where it lives tab.
//
//   Remove: Shopify placements are taken down by the client through ShopifyService (the store token lives
//   there) and reported with /removed; networks with a delete API go through the worker (status "removing"
//   until it answers); Instagram and TikTok have no delete API, the user removes the post in the app and
//   confirms here. A sent email cannot be unsent.

function svc(api) {
  const S = ServiceFactory.getType(api, "product");
  return new S();
}
const toast = m => {
  const t = document.querySelector("paper-toast");
  if (t && m) t.show(m);
};
export const TARGET_LABEL = {
  shopify_product: "Shopify · product description",
  shopify_article: "Shopify · blog post",
  shopify_page: "Shopify · page",
  shopify_media: "Shopify · product media",
  shopify_translate: "Shopify · translation",
  shopify_translation: "Shopify · translation",
  email_draft: "Plunk · email automation",
  plunk_campaign: "Plunk · email automation",
  plunk_journey: "Plunk · journey",
  email: "Plunk · email",
  instagram: "Instagram · post",
  social_instagram: "Instagram · post",
  facebook: "Facebook · post",
  social_facebook: "Facebook · post",
  meta: "Facebook / Instagram",
  gbp: "Google Business · post",
  gbp_post: "Google Business · post",
  google_business: "Google Business · post",
  pinterest: "Pinterest · pin",
  social_pinterest: "Pinterest · pin",
  linkedin: "LinkedIn · post",
  social_linkedin: "LinkedIn · post",
  youtube: "YouTube · video",
  tiktok: "TikTok · video",
  wordpress: "WordPress · post",
  custom_api: "Custom API",
  website: "Website",
  mailchimp: "Mailchimp · campaign",
  constant_contact: "Constant Contact",
  manual: "Published by you"
};
export const targetName = t => TARGET_LABEL[String(t || "").toLowerCase()] || String(t || "—").replace(/_/g, " ");
const ICON = t => {
  const k = String(t || "").toLowerCase();
  if (/email|campaign|journey|mailchimp|constant/.test(k)) return "mail_outline";
  if (/youtube|tiktok|media|video/.test(k)) return "movie";
  if (/pinterest/.test(k)) return "push_pin";
  if (/instagram/.test(k)) return "photo_camera";
  if (/facebook|meta/.test(k)) return "thumb_up_off_alt";
  if (/linkedin/.test(k)) return "work_outline";
  if (/gbp|google/.test(k)) return "storefront";
  if (/article|page|wordpress|website/.test(k)) return "article";
  if (/product/.test(k)) return "inventory_2";
  return "public";
};
export const isLive = p => !["failed", "retired", "removed", "deleted"].includes(String(p && p.status || "").toLowerCase());
export const isShopify = t => String(t || "").toLowerCase().startsWith("shopify_");
const OWNED_UPDATE = new Set(["shopify_product", "shopify_article", "shopify_page", "wordpress"]);
const MANUAL = new Set(["instagram", "social_instagram", "tiktok", "social_tiktok"]);
// YouTube: Plunk's Google grant is upload + read-only, and videos.delete needs a wider scope (403 insufficient scopes, 2026-10-08).
// The video is deleted in YouTube Studio and confirmed here, like Instagram and TikTok.
const STUDIO = new Set(["youtube", "social_youtube"]);
const studioUrl = pub => pub && pub.externalId ? `https://studio.youtube.com/video/${encodeURIComponent(pub.externalId)}/edit` : pub && pub.url || "";
const NO_REMOVE = new Set(["plunk_campaign", "plunk_journey", "email", "email_draft", "mailchimp", "constant_contact", "shopify_translate", "shopify_translation"]);
// Placements Plunk itself put on a network (everything else here is an imported attribution: a crawled page, an ad campaign) 
const REMOVABLE = t => isShopify(t) || ["wordpress", "facebook", "social_facebook", "instagram", "social_instagram", "linkedin", "social_linkedin", "pinterest", "social_pinterest", "gbp", "gbp_post", "google_business", "youtube", "tiktok", "custom_api", "manual"].includes(t);
/** Placements Plunk itself shipped (from the Builder or the piece page), as opposed to imported attributions (crawled pages, ad campaigns). */
export const shippedByPlunk = t => {
  const k = String(t || "").toLowerCase();
  return REMOVABLE(k) || ["plunk_campaign", "plunk_journey", "email_draft", "meta", "shopify_translate", "shopify_translation", "mailchimp", "constant_contact"].includes(k);
};
const STATUS_CLS = {
  live: "ok",
  published: "ok",
  sent: "ok",
  draft: "info",
  queued: "info",
  removing: "warn",
  failed: "danger",
  retired: "muted",
  removed: "muted",
  private: "warn"
};
const day = s => s && !/^0001/.test(String(s)) ? String(s).slice(0, 10) : "";
const host = u => {
  try {
    return new URL(u).hostname.replace(/^www\./, "");
  } catch (e) {
    return u;
  }
};

/** What Remove does for this placement, in the user's words. */
export function removeCopy(pub, v) {
  const t = String(pub && pub.target || "").toLowerCase();
  if (t === "shopify_product") return {
    title: "Restore the previous product copy",
    body: "The product description goes back to the copy it had before Plunk wrote it (kept at publish time). The product stays live.",
    cta: "Restore previous copy",
    danger: false
  };
  if (t === "shopify_article") return {
    title: "Remove from your Shopify blog",
    body: "The blog post is deleted from Shopify. Links to it will stop working. The piece goes back to approved, so you can publish it again later.",
    cta: "Remove from Shopify",
    danger: true
  };
  if (t === "shopify_page") return {
    title: "Remove from your Shopify store",
    body: "The page is deleted from Shopify. Links to it will stop working. The piece goes back to approved, so you can publish it again later.",
    cta: "Remove from Shopify",
    danger: true
  };
  if (t === "shopify_media") return {
    title: "Remove from the product page",
    body: "The video is removed from the product's media in Shopify.",
    cta: "Remove media",
    danger: true
  };
  if (t === "wordpress") return {
    title: "Remove from WordPress",
    body: "The post is deleted from your WordPress site (not just trashed). Takes about a minute.",
    cta: "Remove from WordPress",
    danger: true
  };
  if (STUDIO.has(t)) return {
    title: "Delete in YouTube Studio",
    body: "Plunk can upload to YouTube but not delete. Open the video in YouTube Studio, choose the ⋮ menu, then Delete forever. Confirm here afterwards so the piece can ship again.",
    cta: "I deleted it",
    danger: false,
    manual: true,
    openUrl: studioUrl(pub),
    openLabel: "Open in YouTube Studio"
  };
  if (MANUAL.has(t)) {
    const n = /tiktok/.test(t) ? "TikTok" : "Instagram";
    return {
      title: `Remove in the ${n} app`,
      body: `${n} has no delete API. Open the post, delete it in the ${n} app, then confirm here so the piece can ship again.`,
      cta: "I removed it",
      danger: false,
      manual: true
    };
  }
  if (t === "custom_api") return {
    title: "Mark as removed",
    body: "Your endpoint owns this object: remove it there, then confirm here so the piece can ship again.",
    cta: "I removed it",
    danger: false,
    manual: true
  };
  if (t === "manual") return {
    title: "Mark as removed",
    body: "You published this yourself: take it down there, then confirm here so the piece can ship again.",
    cta: "I removed it",
    danger: false,
    manual: true
  };
  const n = targetName(t).split(" · ")[0];
  return {
    title: `Remove from ${n}`,
    body: `The post is deleted from ${n} through its API. Comments and reactions on it go with it. Takes about a minute; the row shows "removing" until ${n} confirms.`,
    cta: `Remove from ${n}`,
    danger: true
  };
}

/** Take a placement down. Returns the final status string; throws with a message the user can read. */
export async function removePublication({
  pub,
  v,
  d,
  shop
}) {
  const vid = String(v.id);
  const pid = String(pub.id);
  const t = String(pub.target || "").toLowerCase();
  if (NO_REMOVE.has(t)) throw new Error("A sent email cannot be unsent.");
  if (isShopify(t)) {
    const kind = t === "shopify_product" ? "product" : t === "shopify_article" ? "article" : t === "shopify_page" ? "page" : "media";
    const link = (d && d.links || []).find(l => String(l.linkType || l.link_type || "").toLowerCase() === "product");
    const prev = (d && d.blocks || []).filter(b => String(b.kind || "") === `previous_${t}` && (!b.assetRef || String(b.assetRef) === String(pub.externalId || ""))).sort((a, b) => (b.version || 0) - (a.version || 0))[0];
    const base = String(endpoints.product.root || "").replace(/\/v1\/?$/, "");
    const h = await bearerHeaders();
    h["content-type"] = "application/json";
    const r = await fetch(`${base}/shopify/content/unpublish`, {
      method: "POST",
      headers: h,
      body: JSON.stringify({
        shop,
        kind,
        externalId: pub.externalId,
        productId: link ? link.refId || link.ref_id : undefined,
        previousHtml: prev ? prev.body : undefined
      })
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.error || `Shopify did not remove it (${r.status})`);
    await svc(`/content/variants/${vid}/publications/${pid}/removed`).postAsync({});
    return "retired";
  }
  if (STUDIO.has(t)) {
    await svc(`/content/variants/${vid}/publications/${pid}/removed`).postAsync({});
    return "retired";
  }
  const res = await svc(`/content/variants/${vid}/publications/${pid}/remove`).postAsync({});
  const mode = res && res.mode;
  if (mode === "done") return String(res.status || "retired");
  if (mode === "manual") {
    await svc(`/content/variants/${vid}/publications/${pid}/removed`).postAsync({});
    return "retired";
  }
  if (mode === "client") return removePublication({
    pub: {
      ...pub,
      target: res.target || pub.target
    },
    v,
    d,
    shop
  });
  // worker: poll until the row leaves "removing"
  for (let i = 0; i < 18; i++) {
    await new Promise(ok => setTimeout(ok, 4000));
    const list = await svc(`/content/variants/${vid}/publications`).getAsync().catch(() => null);
    const row = list && (list.items || []).find(p => String(p.id) === pid);
    if (row && String(row.status || "").toLowerCase() !== "removing") {
      if (isLive(row)) throw new Error(`${targetName(t).split(" · ")[0]} did not remove it. Try again, or remove it in the app.`);
      return String(row.status || "retired");
    }
  }
  return "removing";
}

/**
 * items: [{ pub, v, d }] · shop: Shopify shop domain (for client-side removes) · onChanged(): reload after a remove
 * onAgain(pub, v): "Update" on a live owned placement or "Publish again" on a retired one (the host ticks its Ship row).
 */
export class ShippedList extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      confirm: null,
      busy: {},
      all: false
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "run", async it => {
      const key = String(it.pub.id);
      this.setState({
        confirm: null,
        busy: {
          ...this.state.busy,
          [key]: true
        }
      });
      try {
        const status = await removePublication({
          pub: it.pub,
          v: it.v,
          d: it.d,
          shop: this.props.shop
        });
        toast(status === "removing" ? "Still removing: the row updates when the network answers." : "Removed. The piece is back to approved.");
      } catch (e) {
        toast(e && e.message && e.message.length < 200 ? e.message : "Remove failed.");
      } finally {
        if (this._alive) this.setState({
          busy: {
            ...this.state.busy,
            [key]: false
          }
        });
        if (this.props.onChanged) this.props.onChanged();
      }
    });
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    const {
      items,
      onAgain,
      compact
    } = this.props;
    const {
      confirm,
      busy
    } = this.state;
    if (!items || !items.length) return this.props.empty || null;
    const limit = this.props.limit || 0;
    const shown = limit && !this.state.all && items.length > limit ? items.slice(0, limit) : items;
    return /*#__PURE__*/React.createElement("div", {
      className: "hub-shp" + (compact ? " compact" : "")
    }, shown.map(it => {
      const {
        pub,
        v
      } = it;
      const t = String(pub.target || "").toLowerCase();
      const st = String(pub.status || "").toLowerCase() || "live";
      const live = isLive(pub);
      const k = String(pub.id);
      const b = !!busy[k];
      // readOnly: an imported piece (social / website / campaign import) was posted natively, not by Plunk: Open only.
      const canUpdate = live && OWNED_UPDATE.has(t) && onAgain && !this.props.readOnly;
      const canRemove = live && REMOVABLE(t) && st !== "removing" && !this.props.readOnly;
      return /*#__PURE__*/React.createElement("div", {
        key: k,
        className: "hub-shp-row" + (live ? "" : " off")
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons ic"
      }, ICON(t)), /*#__PURE__*/React.createElement("span", {
        className: "t"
      }, /*#__PURE__*/React.createElement("b", null, this.props.pieceLabel ? this.props.pieceLabel(v) : null, this.props.pieceLabel ? " → " : "", targetName(t)), pub.url ? /*#__PURE__*/React.createElement("a", {
        href: pub.url,
        target: "_blank",
        rel: "noreferrer",
        title: pub.url
      }, host(pub.url), /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "open_in_new")) : /*#__PURE__*/React.createElement("i", null, st === "retired" ? "removed" : st === "failed" ? "the network refused it" : st === "queued" || st === "draft" ? "waiting for the network's link" : "no public link")), /*#__PURE__*/React.createElement("span", {
        className: "plk-chip " + (STATUS_CLS[st] || ""),
        title: st === "private" ? "YouTube kept this video private. Videos uploaded from Plunk stay private until Google approves Plunk's YouTube API audit." : undefined
      }, st === "removing" ? "removing…" : st === "private" ? "private on YouTube" : st), /*#__PURE__*/React.createElement("span", {
        className: "d"
      }, day(pub.publishedDate) || day(pub.createdDate) || "—"), /*#__PURE__*/React.createElement("span", {
        className: "acts"
      }, pub.url && live && /*#__PURE__*/React.createElement("a", {
        className: "territory-toggle sm",
        href: pub.url,
        target: "_blank",
        rel: "noreferrer"
      }, "Open"), canUpdate && /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle sm",
        title: "Push the current copy to the same place",
        onClick: () => onAgain(pub, v, "update")
      }, "Update"), canRemove && !b && /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle sm" + (MANUAL.has(t) || STUDIO.has(t) ? "" : " danger"),
        onClick: () => this.setState({
          confirm: it
        })
      }, STUDIO.has(t) ? "Remove in YouTube Studio" : MANUAL.has(t) ? "Remove in the app" : "Remove"), b && /*#__PURE__*/React.createElement("span", {
        className: "territory-hint",
        style: {
          margin: 0
        }
      }, "removing\u2026"), !live && onAgain && REMOVABLE(t) && !this.props.readOnly && /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle sm",
        onClick: () => onAgain(pub, v, "again")
      }, "Publish again"), live && NO_REMOVE.has(t) && /*#__PURE__*/React.createElement("span", {
        className: "plk-chip muted",
        title: "A sent email cannot be unsent"
      }, "no remove")));
    }), shown.length < items.length && /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      style: {
        alignSelf: "flex-start",
        margin: "2px 0 0"
      },
      onClick: () => this.setState({
        all: true
      })
    }, "Show all ", items.length), confirm && (() => {
      const c = removeCopy(confirm.pub, confirm.v);
      const close = () => this.setState({
        confirm: null
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "wa-modal-backdrop hub-edit-backdrop",
        onClick: close
      }, /*#__PURE__*/React.createElement("div", {
        className: "hub-trash-sheet hub-shp-sheet",
        onClick: e => e.stopPropagation()
      }, /*#__PURE__*/React.createElement("div", {
        className: "eyebrow"
      }, "Remove"), /*#__PURE__*/React.createElement("h3", {
        className: "hub-h3",
        style: {
          margin: "0 0 2px"
        }
      }, c.title), /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: "0 0 10px"
        }
      }, this.props.pieceLabel ? `${this.props.pieceLabel(confirm.v)} → ` : "", targetName(confirm.pub.target), confirm.pub.url ? ` · ${host(confirm.pub.url)}` : ""), /*#__PURE__*/React.createElement("div", {
        className: "hub-shp-what" + (c.manual ? " manual" : "")
      }, c.body), /*#__PURE__*/React.createElement("div", {
        className: "hub-shp-foot"
      }, /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle sm",
        onClick: close
      }, "Cancel"), /*#__PURE__*/React.createElement("span", {
        style: {
          flex: 1
        }
      }), c.manual && (c.openUrl || confirm.pub.url) && /*#__PURE__*/React.createElement("a", {
        className: "territory-toggle sm",
        href: c.openUrl || confirm.pub.url,
        target: "_blank",
        rel: "noreferrer"
      }, c.openLabel || "Open the post"), /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-sm k-rounded-md k-button-solid " + (c.danger ? "hub-shp-danger" : "k-button-solid-primary"),
        onClick: () => this.run(confirm)
      }, c.cta))));
    })());
  }
}
export default ShippedList;